/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/common/app';
export default class AchievementCategoriesState {
  /**
   * @param {Record<string, unknown>} params Query parameters for the categories load.
   */
  constructor(params) {
    if (params === void 0) {
      params = {};
    }
    this.params = params;
  }
  async refresh(clear, initial) {
    if (clear === void 0) {
      clear = false;
    }
    if (initial === void 0) {
      initial = false;
    }
    this.loading = initial;
    this.updating = true;
    this.error = null;
    m.redraw();

    // Every caller is fire-and-forget, so a rejection must not escape.
    try {
      if (clear || app.store.all('achievement_categories').length === 0) {
        this.achievement_categories = await app.store.find('achievement_categories', this.params);
      } else {
        this.achievement_categories = app.store.all('achievement_categories').sort((a, b) => {
          if (a.order() < b.order()) return -1;
          if (a.order() > b.order()) return 1;
          return 0;
        });
      }
      this.active_category = this.achievement_categories[0]?.id();
      if (!initial) {
        this.saved = true;
        setTimeout(() => {
          this.saved = false;
          m.redraw();
        }, 3000);
      }
    } catch (e) {
      // Kept apart from an empty list so a failed load is not rendered as a missing category.
      this.error = e?.status ?? 500;
      this.achievement_categories ??= [];
    } finally {
      this.loading = false;
      this.updating = false;
      m.redraw();
    }
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/states/AchievementCategoriesState', AchievementCategoriesState);